import config from "@shared/config/client";
import { ICallableRequestBuilder } from "../../requestBuilder/types";
import {
  withAuthenticatedClientRequest,
  withClientRequest,
} from "../../requestBuilder/withClientRequest";
import requests from "./requests";
import { PostCommentDto, PostCommentQueryDto } from "./types";

const createPostComment =
  (request: ICallableRequestBuilder<PostCommentDto>) =>
  async (commentQuery: PostCommentQueryDto) => {
    return await request.call(`${config.apiUrl}/comments/post`, (init) => ({
      ...init,
      method: "POST",
      headers: {
        ...init.headers,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(commentQuery),
    }));
  };

const getPostCommentCount =
  (request: ICallableRequestBuilder<number>) => async (id: string) => {
    return await request.call(
      `${config.apiUrl}/comments/post/count/${id}`,
      (init) => ({
        ...init,
        method: "GET",
      }),
    );
  };

const deletePostComment =
  (request: ICallableRequestBuilder<PostCommentDto>) => async (id: string) => {
    return await request.call(
      `${config.apiUrl}/comments/post/${id}`,
      (init) => ({
        ...init,
        method: "DELETE",
      }),
    );
  };

const clientRequests = {
  createPostComment: withAuthenticatedClientRequest(createPostComment),
  getPostCommentCount: withClientRequest(getPostCommentCount),
  deletePostComment: withAuthenticatedClientRequest(deletePostComment),
  getPostComments: withClientRequest(requests.getPostComments),
};

export default clientRequests;
